import {
  HighchartsChartDataSeriesOption,
  HighchartsChartDataType,
} from "@/storybook/c8r-highcharts/common/utils/types/common";
import { Budget, XAxisGranularity } from "@/services/cloudchipr.api";
import { getPlannedBudgetChartSeries } from "@/components/pages/common/billing-explorer/utils/getPlannedBudgetChartSeries";
import { getPlannedBudgetAmount } from "@/components/pages/budgets-and-alerts/components/grids/budgets/utils/helpers/getPlannedBudgetAmount";

export const addBudgetLineIntoBillingExplorerChartData = (
  chartData: HighchartsChartDataType,
  budget: Budget,
  labels: Record<string, string> | null,
  xAxisGranularity?: XAxisGranularity,
  quarterStartMonth?: number,
): HighchartsChartDataType => {
  let budgetSeries: { y: number }[] = [];

  if (xAxisGranularity !== "date" || budget?.type === "fixed") {
    const budgetAmount =
      (budget?.type === "fixed"
        ? budget?.amount
        : budget &&
          getPlannedBudgetAmount(
            budget.start_date,
            budget.period,
            budget.planned_amounts,
            quarterStartMonth,
          )) ?? 0;

    budgetSeries = Array(chartData.categories.length).fill({ y: budgetAmount });
  } else if (budget?.type === "planned") {
    budgetSeries = getPlannedBudgetChartSeries(chartData, budget, labels);
  }

  const budgetLine: HighchartsChartDataSeriesOption = {
    name: budgetSeriesName,
    type: "line",
    color: "red",
    dashStyle: "Dash",
    step: "center",
    data: budgetSeries,
    marker: { enabled: false },
    lineWidth: 2,
    purpose: "visualization",
  };

  return {
    ...chartData,
    series: [...chartData.series, budgetLine],
  };
};

export const budgetSeriesName = "Budget";
